var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.data ? _vm.data.id : null,
      staticClass: "card-info-item-container"
    },
    [
      _c(
        "div",
        { staticClass: "card-info", style: _vm.cardInfoItemStyling },
        [
          _vm.editingData
            ? _c("InputField", {
                key: _vm.data,
                attrs: {
                  "input-type": "select",
                  value: _vm.data.id,
                  label: _vm.editableLabel,
                  "select-options-list": _vm.editableInputOptions,
                  "input-disabled": _vm.editingData && _vm.specialDisable,
                  size: "large",
                  inputFieldContainerStyling: { padding: "0" }
                },
                on: {
                  input: function($event) {
                    return _vm.updateField($event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card-info-container",
              style: _vm.editingData ? "margin-top: 20px" : ""
            },
            [
              !_vm.editingData
                ? _c(
                    "div",
                    { staticClass: "card-info-item" },
                    [
                      _c("v-icon", { staticClass: "card-icon" }, [
                        _vm._v("apartment")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "card-info-item-label" }, [
                        _vm._v(_vm._s(_vm.$tc("Company", 1)) + ": ")
                      ]),
                      _vm._v(" "),
                      _vm.data
                        ? _c("span", { staticClass: "card-info-item-value" }, [
                            _vm._v(_vm._s(_vm.data.name) + " ")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-info-item" },
                [
                  _c("v-icon", { staticClass: "card-icon" }, [
                    _vm._v("location_on")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "card-info-item-label" }, [
                    _vm._v(_vm._s(_vm.$tc("Address", 1)) + ": ")
                  ]),
                  _vm._v(" "),
                  _vm.data
                    ? _c("span", { staticClass: "card-info-item-value" }, [
                        _vm._v(_vm._s(_vm.data.address) + " ")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-info-item" },
                [
                  _c("v-icon", { staticClass: "card-icon" }, [_vm._v("mail")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "card-info-item-label" }, [
                    _vm._v(_vm._s(_vm.$tc("E-mail", 1)) + ": ")
                  ]),
                  _vm._v(" "),
                  _vm.data
                    ? _c("span", { staticClass: "card-info-item-value" }, [
                        _vm._v(_vm._s(_vm.data.email) + " ")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-info-item" },
                [
                  _c("v-icon", { staticClass: "card-icon" }, [_vm._v("call")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "card-info-item-label" }, [
                    _vm._v(_vm._s(_vm.$tc("Phone", 1)) + ": ")
                  ]),
                  _vm._v(" "),
                  _vm.data
                    ? _c("span", { staticClass: "card-info-item-value" }, [
                        _vm._v(_vm._s(_vm.data.phone) + " ")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-info-item" },
                [
                  _c("v-icon", { staticClass: "card-icon" }, [_vm._v("label")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "card-info-item-label" }, [
                    _vm._v(_vm._s(_vm.$tc("Level", 1)) + ": ")
                  ]),
                  _vm._v(" "),
                  _vm.data
                    ? _c("span", { staticClass: "card-info-item-value" }, [
                        _vm._v(_vm._s(_vm.companyLevelLabel) + " ")
                      ])
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff7ea770", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff7ea770","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Organisms/SingleEditObjectMainInfoCompanies.vue
// module id = null
// module chunks = 